import styles from './GenerateDescriptionChat.module.scss';
import { useScopedTranslation } from 'application/localization/useScopedTranslation.ts';
import { Trans } from 'react-i18next';
import { ChatBot } from '../chatBot/ChatBot.tsx';
import { GenerateDescriptionHeader } from './GenerateDescriptionHeader.tsx';
import { DocumentVariable } from 'pages/authorized/documents/components/richedit-helper.ts';
import { QueryFactory } from 'services/api';
import { FeatureFlags } from 'application/constants/env-variables.ts';

type GenerateDescriptionChatProps = {
  isOpen?: boolean;
  onClose: () => void;
  documentVariable?: DocumentVariable;
  revisionId?: number;
  projectId?: number;
};

export const GenerateDescriptionChat = (
  props: GenerateDescriptionChatProps,
) => {
  const i18n = useScopedTranslation('Component.GenerateDescriptionChat');

  const sendGenerateDescription =
    !props.projectId || !props.documentVariable || !props.revisionId
      ? undefined
      : async () => {
          const result = await QueryFactory.LLMClient.describeVariable({
            variableId: props.documentVariable!.id,
            revisionId: props.revisionId!,
            projectId: props.projectId!,
            postfix: props.documentVariable!.postfix,
            userPrompt: '',
          });

          return {
            text: result.response,
            isLlmResponse: true,
            responseId: result.responseId,
          };
        };

  return (
    <ChatBot
      isOpen={props.isOpen}
      sendInitialMessage={sendGenerateDescription}
      header={<GenerateDescriptionHeader onClose={props.onClose} />}
      placeholder={{
        mainText: i18n.t('placeholder.main_text'),
        helperText: FeatureFlags.aiChatEnabled() && (
          <Trans
            i18nKey={
              'Component.GenerateDescriptionChat.placeholder.helper_text'
            }
            components={{
              purple: <span className={styles.purple} />,
            }}
          />
        ),
      }}
    />
  );
};
